import React, { createContext, useContext, useState } from 'react';

// Create notification context
const NotificationContext = createContext();

// Custom hook to use the notification context
export const useNotification = () => {
    const context = useContext(NotificationContext);
    if (!context) {
        throw new Error('useNotification must be used within a NotificationProvider');
    }
    return context;
};

// Notification provider component
export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);

    // Function to add a new notification
    const addNotification = (message, type = 'info', duration = 5000) => {
        const id = Date.now();
        setNotifications((prev) => [...prev, { id, message, type, duration }]);

        // Auto-remove notification after duration
        setTimeout(() => {
            removeNotification(id);
        }, duration);

        return id;
    };

    // Function to remove notification by ID
    const removeNotification = (id) => {
        setNotifications((prev) => prev.filter((notification) => notification.id !== id));
    };

    // Helper functions for common notification types
    const notify = {
        success: (message, duration) => addNotification(message, 'success', duration),
        error: (message, duration) => addNotification(message, 'error', duration),
        warning: (message, duration) => addNotification(message, 'warning', duration),
        info: (message, duration) => addNotification(message, 'info', duration),
    };

    return (
        <NotificationContext.Provider value={{ notifications, addNotification, removeNotification, notify }}>
            {children}
        </NotificationContext.Provider>
    );
};

export { NotificationContext }; 